import axios from "../service/axios/axios";
export default {
  //获取问诊费对账记录列表
  getConsultCostList(data) {
    return axios({
      method: "post",
      url: "platform/cost/getConsultCostList",
      data: data,
    });
  },
  //获取问诊费对账记录详情
  getConsultCostInfo({ consult_id }) {
    return axios({
      method: "post",
      url: "platform/cost/getConsultCostInfo",
      data: { consult_id },
    });
  },
  //诊后管理费/诊金记录列表
  getOrderCostList(data) {
    return axios({
      method: "post",
      url: "platform/cost/getOrderCostList",
      data: data,
    });
  },
  //诊后管理费/诊金记录详情
  getOrderCostInfo({ order_id }) {
    return axios({
      method: "post",
      url: "platform/cost/getOrderCostInfo",
      data: { order_id },
    });
  },
  //获取平台奖励记录
  getRewardList(data) {
    return axios({
      method: "post",
      url: "platform/doctor/getRewardList",
      data: data,
    });
  },
  // 导出平台奖励记录
  exportRewardList(data) {
    return axios({
      method: "post",
      url: "platform/doctor/exportRewardList",
      data: data,
    });
  },
  //获取平台奖励详情
  getRewardInfo({ reward_id }) {
    return axios({
      method: "post",
      url: "platform/doctor/getRewardInfo",
      data: { reward_id },
    });
  },
  //获取费用结算列表
  getFeeSettlementList(data) {
    return axios({
      method: "post",
      url: "platform/cost/getFeeSettlementList",
      data: data,
    });
  },
  // 获取费用结算详情
  getFeeSettlementInfo({ sa_id }) {
    return axios({
      method: "post",
      url: "platform/cost/getFeeSettlementInfo",
      data: { sa_id },
    });
  },
  // 获取费用结算明细列表
  getFeeSettlementItemList(data) {
    return axios({
      method: "post",
      url: "platform/cost/getFeeSettlementItemList",
      data: data,
    });
  },
  //结算入账
  settlement({ sa_id }) {
    return axios({
      method: "post",
      url: "platform/cost/settlement",
      data: { sa_id },
    });
  },
  //获取提现列表
  getCashoutList(data) {
    return axios({
      method: "post",
      url: "platform/cost/getCashoutList",
      data: data,
    });
  },
  //确认打款
  confirmPayment({ ca_id }) {
    return axios({
      method: "post",
      url: "platform/cost/confirmPayment",
      data: { ca_id },
    });
  },
  //提现管理导出功能
  exportCashoutList({ ca_id }) {
    return axios({
      method: "post",
      url: "platform/cost/exportCashoutList",
      data: { ca_id },
    });
  },
  //项目推荐奖励列表
  getDoctorRewardList(data) {
    return axios({
      method: "post",
      url: "platform/cost/getDoctorRewardList",
      data: data,
    });
  },
  //项目推荐详情
  getDoctorRewardDetail({ order_id }) {
    return axios({
      method: "post",
      url: "platform/cost/getDoctorRewardDetail",
      data: { order_id },
    });
  },
  /***** 商品推荐奖励---start  ****/
  // 获取商品推荐奖励列表
  getAwardList(data) {
    return axios({
      method: "post",
      url: "platform/Recommendgoods/getAwardList",
      data: data,
    });
  },
  // 获取商品推荐奖励详情
  getAwardDetail(data) {
    return axios({
      method: "post",
      url: "platform/Recommendgoods/getAwardDetail",
      data: data,
    });
  },
  /***** 商品推荐奖励---end  ****/
  /***** 终身分佣奖---start  ****/
  // 获取医生终身分佣奖励列表
  getForeverOrderList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/getForeverOrderList",
      data: data,
    });
  },
  // 获取终身分佣奖励详情
  getForeverOrderInfo(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/getForeverOrderInfo",
      data: data,
    });
  },
  // 获取不可终身分佣商品列表
  getForeverGoodsList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/getForeverGoodsList",
      data: data,
    });
  },
  // 获取不可分佣商品列表
  getGoodsList(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/getGoodsList",
      data: data,
    });
  },
  // 添加不可分佣商品
  saveForeverGoods(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/saveForeverGoods",
      data: data,
    });
  },
  // 删除不可分佣商品数据
  deleteForeverGoods(data) {
    return axios({
      method: "post",
      url: "platform/Doctorreward/deleteForeverGoods",
      data: data,
    });
  },
  /***** 终身分佣奖---end  ****/
  /***** 锦旗记录---start  ****/
  // 获取锦旗记录
  getSilkCostLog(data) {
    return axios({
      method: "post",
      url: "platform/cost/getSilkCostLog",
      data: data,
    });
  },
  // 获取赠送金额列表
  getSilkMoneyList(data) {
    return axios({
      method: "post",
      url: "platform/cost/getSilkMoneyList",
      data: data,
    });
  },
  /***** 锦旗记录---end  ****/
};
